module.exports = __webpack_public_path__ + "img/product-shot_09.074fb3ed.jpg";